/**
 * 单据编码接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InvoiceCodeService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

 //#region 单据编码接口
  /**
   * 分页查询单据编码
   * @param param
   * @returns {Observable<any>}
   */
  queryInvoiceCodePageList(param) {
    const url = this.prefix + 'serialno/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 新增单据编码
   * @param param
   * @returns {Observable<any>}
   */
  saveInvoiceCode(param) {
    const url = this.prefix + 'serialno/save';
    return this.http.Post(url, param);
  }

  /**
   * 查询单据编码信息
   * @param param
   */
  getInvoiceCode(param) {
    const url = this.prefix + 'serialno/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 修改单据编码
   * @param param
   * @returns {Observable<any>}
   */
  updateInvoiceCode(param) {
    const url = this.prefix + 'serialno/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除单据编码
   * @param param
   * @returns {Observable<any>}
   */
  deleteInvoiceCode(param) {
    const url = this.prefix + 'serialno/deleteBatch';
    return this.http.Post(url, param);
  }

  //#endregion

}
